import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';

import { ActivatedRoute, Router, TitleStrategy } from '@angular/router';
import { Product2 } from '@interfaces/all-products';
import { generateDummyBarcodeFromDefinition, LikutScanService } from '@services/likut-scan.service';
import { DuplicationError, IllegalActionError, IllegalStateError, ValidationError } from '@utils/Errors';
import { compress, decompress } from 'lz-string';
import { Observable, Subscription, Subject, BehaviorSubject, fromEvent, takeUntil, map, startWith, combineLatest, delay, filter, scan, take, merge } from 'rxjs';
import { LikutSubSQL, LikutKabalaSubSQL, LikutProductBarcodeWithDefinition, scanHistoryOriginSource, LStatusesDict, NewLikutMekabelWarehouseFormResult, MekabelWarehouse } from '@interfaces/likut';
import { AllProducts } from '@interfaces/SQL-morning-responses';
import { AdminTypes } from '@interfaces/users';
import { AlertService } from '@services/alert.service';
import { BarcodeService } from '@services/barcode.service';
import { BottomPopupService } from '@services/bottom-popup.service';
import { IndexedDBService } from '@services/indexed-db.service';
import { LikutService } from '@services/likut.service';
import { StoreService } from '@services/store.service';
import { TextService } from '@services/text.service';
import { UtilService } from '@services/util.service';
import { MAX_DISCOUNT, MAX_PRODUCT_PRICE } from 'src/app/Utility/constants-products';
import { formatNumberToMaxPrecision, genericSearchingFunction, normalizeNumber, range } from 'src/app/Utility/functions';
import { environment } from 'src/environments/environment';
import { SubAppModes } from '../likut-clients/likut-clients.component';
import { getLineIdentifier } from '../likut-task/methods';
import { LikutClientsWarehouseDialogComponent } from '@components/likut-clients/likut-clients-warehouse-dialog.component';
// import { LikutTaskChooseScanToAddComponent } from './likut-task-choose-scan-to-add/likut-task-choose-scan-to-add.component';
type Opened = { opened?: boolean };

type ProductDisplayBase = { product?: AllProducts; matchesSearch?: boolean };

export type ProductDisplay = ProductDisplayBase;

export type ProductDisplayLikutOrTruck = ProductDisplay | LikutProductDisplayNewRoute;

export type LikutProductDisplayNewRoute = ProductDisplayBase & {
	likut: LikutSubSQL;
	opened?: boolean;
	mismatchedQuantitiesToShowChecker?: boolean;
	quantitiesMatchOrExceed?: boolean;
};

export type LikutMekabelDisplay = { likut: LikutKabalaSubSQL; opened?: boolean; matchesSearch?: boolean; taskIdentifier: string; quantitiesMatchOrExceed?: boolean };

@Component({
	selector: 'app-likut-task-sfira',
	templateUrl: './likut-task-sfira.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ['./likut-task-sfira.component.scss'],
})
export class LikutTaskSfiraComponent implements OnInit, OnDestroy {
	_likutScan = inject(LikutScanService);
	constructor(
		public _ss: StoreService,
		private _router: Router,
		private _fb: FormBuilder,
		public _likut: LikutService,
		private _alert: AlertService,
		private dialog: MatDialog,
		private _bottomPopup: BottomPopupService,
		private _change: ChangeDetectorRef,
		public _text: TextService,
		// private _util: UtilService,
		// private _idb: IndexedDBService,
		private _acr: ActivatedRoute,
		private _barcode: BarcodeService,
	) {}

	isDevelopment = environment.development;

	productSearch = new FormControl('', { nonNullable: true });

	form = this._fb.group({
		collected: [<number>null],
		collectedPacks: [<number>null],
		price: [<number>null],
		discount: [<number>null],
		eitur: new FormControl('', { nonNullable: true }),
		remark: new FormControl('', { nonNullable: true }),
	});
	allProducts: Record<string, AllProducts> = {};
	AllOrder = [];
	Admin: AdminTypes | null = localStorage.getItem('Admin') as AdminTypes | null;

	checkboxState: { [productIDAndTeudaNumAndLineNum: string]: boolean } = {};
	validQuantitiesState: { [productIDAndTeudaNumAndLineNum: string]: boolean } = {};

	clientName: string;

	productDisplay$ = new BehaviorSubject<ProductDisplay[]>([]);
	isCheckerReturnPopupOpen$ = new BehaviorSubject(false);
	isMelaketReleasePopupOpen$ = new BehaviorSubject(false);

	pageMode$ = new BehaviorSubject<SubAppModes>(location.pathname.split('/')[1] as SubAppModes);
	likutProductDisplayNewRoutes$ = new BehaviorSubject<LikutProductDisplayNewRoute[]>([]);
	isTrucks$ = this.pageMode$.pipe(map(page => page.includes('truck')));
	isEditQuantityPopupShown$ = new BehaviorSubject(false);
	isNormalPopupShown$ = this.isEditQuantityPopupShown$.pipe(map(value => value && !this.isLikutMekabel));
	isLikutMekabelPopupShown$ = this.isEditQuantityPopupShown$.pipe(map(value => value && this.isLikutMekabel));

	likutMekabelDisplay$ = new BehaviorSubject<LikutMekabelDisplay[]>([]);

	readonly totalShown$ = new BehaviorSubject(0);

	windowVisibilityObservable$: Observable<Event>;
	windowVisibilitySubscription$: Subscription;

	private destroy$ = new Subject<void>();

	windowWidth = innerWidth;

	isBarcodePopupOpen$ = new BehaviorSubject(false);
	supportsVideo = true;
	@ViewChild('videoElement') videoElement: ElementRef<HTMLVideoElement>;
	video: HTMLVideoElement;
	mediaStream: MediaStream;
	detectedCode = '';
	intervalID;

	currentlyEdittedTask: ProductDisplayLikutOrTruck;
	currentlyEdittedTaskLikutMekabel: LikutMekabelDisplay;

	currentlyEdittedLikutTask$ = new BehaviorSubject<LikutProductDisplayNewRoute | null>(null);
	currentlyEdittedLikutMekabelTask$ = new BehaviorSubject<LikutMekabelDisplay | null>(null);

	isLocal = !environment.production;

	isLikut = location.pathname.includes('likut');
	isLikutMekabel = location.pathname.includes('mekabel');
	// isTruckLoading = location.pathname.includes('truck-loading');
	// isTruckDistribution = location.pathname.includes('truck-distribution');
	isNewTask = this._acr.snapshot.queryParams['new'] === 'true';
	canAddItems = true;

	isLikutMekabelOrderTeudaType = this.isLikutMekabel && this._likut.isKabalaTeudaTypeOrder(this._likut.getCurrentTeudaType());
	isLikutMekabelReturnTeudaType = this.isLikutMekabel && this._likut.isKabalaTeudaTypeReturn(this._likut.getCurrentTeudaType());

	isLikutScannerActive = this.isLikut && this._likut.hasScannerBehavior && !this._likut.isCheckerAgent;

	isAddNewProductForMekabelPopupOpen$ = new BehaviorSubject(false);
	addProductFormControl = new FormControl('', { nonNullable: true });
	addProductSearch$ = new Observable<AllProducts[]>();
	allProductsForAddNewProductPopup: AllProducts[] = [];
	selectedProductForAddNewProductPopup$ = new BehaviorSubject<AllProducts>(null);
	productsAlreadyAddedSet = new Set<string>();

	productToBeDeleted$ = new BehaviorSubject<LikutMekabelDisplay | null>(null);
	melaketProductToBeDeleted$ = new BehaviorSubject<LikutProductDisplayNewRoute | null>(null);
	isDeleteProductPopupShown$ = combineLatest([this.productToBeDeleted$, this.melaketProductToBeDeleted$]).pipe(map(values => values.some(value => !!value)));
	//likut-scan
	totalScanQuantityForCurrentItem$ = combineLatest([
		this.isEditQuantityPopupShown$,
		this._likutScan.likutBarcodeScans$,
		merge(this.currentlyEdittedLikutTask$, this.currentlyEdittedLikutMekabelTask$),
	]).pipe(
		filter(([shown]) => shown),
		map(([_, scans, currentTask]) => {
			if (!this.isProductWithLikut(currentTask) && !this.isProductWithLikutMekabel(currentTask)) {
				return null;
			}
			const totalScans = scans.filter(scan => scan.rowId === String(currentTask.likut.TeudaLineNum) && scan.teudanum === currentTask.likut.TeudaNum);
			if (!totalScans) {
				return null;
			}
			return totalScans.reduce((p, c) => p + c.qty, 0);
		}),
	);
	anyScansForCurrentItem$ = this._likutScan.likutBarcodeScansDisplay$.pipe(map(scans => !!scans.length));

	likutProductDisplayNewRoutesDisplay$ = combineLatest([this.likutProductDisplayNewRoutes$, this._likutScan.likutBarcodeScansDictionary$]).pipe(
		map(([products, totalScansDict]) => {
			if (!this._likut.isMelaketAgent) {
				return products;
			}

			return products.map(product => {
				let totalQuantity = product.likut.LikutQty;
				let totalPackQuantity = product.likut.LikutPackQty;
				const scans = totalScansDict[this._likutScan.getTaskIdentifierForScan(product.likut)];
				if (!scans) {
					product.quantitiesMatchOrExceed = totalQuantity >= product.likut.TeudaQuantity && totalPackQuantity >= product.likut.TeudaPackQuantity;
					return product;
				}

				for (const scan of scans) {
					totalQuantity += scan.qty;
					totalPackQuantity += scan.packQty;
				}

				if (product.likut.TeudaPackQuantity) {
					product.quantitiesMatchOrExceed = totalPackQuantity >= product.likut.TeudaPackQuantity;
				} else if (product.likut.TeudaQuantity) {
					product.quantitiesMatchOrExceed = totalQuantity >= product.likut.TeudaQuantity;
				}

				return product;
			});
		}),
		map(products => {
			if (this._likut.sortByMatchedQuantities && this._likut.isMelaketAgent) {
				products.sort((a, b) => {
					if (a.quantitiesMatchOrExceed && !b.quantitiesMatchOrExceed) {
						return 1;
					}
					if (!a.quantitiesMatchOrExceed && b.quantitiesMatchOrExceed) {
						return -1;
					}
					return 0;
				});
			}

			return products;
		}),
	);
	likutMekabelDisplayWithScans$ = combineLatest([this.likutMekabelDisplay$, this._likutScan.likutBarcodeScansDictionary$]).pipe(
		map(([products, totalScansDict]) => {
			return products.map(product => {
				let totalQuantity = product.likut.TeudaQtyKabala;
				let totalPackQuantity = product.likut.TeudaPackQtyKabala;
				const scans = totalScansDict[this._likutScan.getTaskIdentifierForScan(product.likut)];
				if (!scans) {
					product.quantitiesMatchOrExceed = totalQuantity >= product.likut.TeudaQty && totalPackQuantity >= product.likut.TeudaPackQty;
					return product;
				}

				for (const scan of scans) {
					totalQuantity += scan.qty;
					totalPackQuantity += scan.packQty;
				}

				if (product.likut.TeudaPackQty) {
					product.quantitiesMatchOrExceed = totalPackQuantity >= product.likut.TeudaPackQty;
				} else if (product.likut.TeudaQty) {
					product.quantitiesMatchOrExceed = totalQuantity >= product.likut.TeudaQty;
				}

				return product;
			});
		}),
	);

	// isDeleteMelaketProductPopupShown$ = this.melaketProductToBeDeleted$.pipe(map(value => !!value));

	taskID = new Date().getTime() + '000' + this._ss.AgentIdConnected;

	private canGoAboveOriginalQuantity = true;

	relevantBarcodeDefinitions: LikutProductBarcodeWithDefinition[] = [];
	shouldConsiderBarcodeDefinitions = this._ss.CustomerInformation.LikutScanner === '2';

	// Template Variables
	inlineItemSize = this.windowWidth > 767 && this.windowWidth < 1099 ? 134 * 1.2 : 134; // is tablet zoom css on, or pc putting 2 inline in 1 row.
	isMobile = this.windowWidth < 768;
	worksInBothSinglesAndPackQuantity = true;
	worksInSinglesQuantity = false;
	worksInPackQuantity = false;
	showLikutExtra1InParenthesis = this._likut.showLikutExtra1InParenthesis;
	dontShowParenthesisAtAll = this._likut.dontShowParenthesisAtAll;
	canSeeTeudaPrice = this._likut.canSeeTeudaPrice;
	// canAddNewItemsAsMelaket = this._likut.isMelaketAgentAndCanAddNewItems;
	teudaName = this._text.store.teudaName;
	refreshStockOnEntryAndDisplay = this._likut.refreshStockOnTaskEntry;
	readonly showBarcodeFromLikut = this._likut.getBarcodeFromSubTable;
	showEitur: boolean | null = null;
	readonly showTeudaItemRemark = this._likut.showTeudaItemRemark;
	readonly hideCheckboxAndPencil = this._likut.hideCheckboxAndPencil;

	readonly isMelaket = this._likut.isMelaketAgent;
	private readonly shouldIgnoreScanListeningWhilePopupOpen = this._likutScan.parameters.shouldIgnoreScanListeningWhilePopupOpen;

	// StoreService Locals
	readonly CustImageDomain: string = this._ss.CustomerInformation?.CustImageDomain;
	LikutType: string = this._ss.CustomerInformation?.LikutType;
	readonly LStatuses = LStatusesDict;

	@ViewChild(CdkVirtualScrollViewport) readonly virtualScroll: CdkVirtualScrollViewport;
	@ViewChild('collected') readonly collectedInput: ElementRef<HTMLInputElement>;
	@ViewChild('collectedPacks') readonly collectedPacksInput: ElementRef<HTMLInputElement>;
	@ViewChild('price') readonly priceInput: ElementRef<HTMLInputElement>;
	@ViewChild('discount') readonly discountInput: ElementRef<HTMLInputElement>;

	readonly totalHandled$ = combineLatest([this.likutProductDisplayNewRoutes$, this.isEditQuantityPopupShown$, this._likutScan.likutBarcodeScans$]).pipe(
		delay(0),
		map(([products, _, allScans]) => {
			if (this._likut.isCheckerAgent) {
				return Object.values(this.checkboxState).filter(value => value).length;
			}
			// TODO see if can be combined with the other if statement, likutqty and likutpackqty are checked in the same way
			if (allScans.length) {
				const activeProducts = new Set(allScans.map(scan => scan.productId));
				return products.filter(product => product.likut.LikutQty > 0 || product.likut.LikutPackQty > 0 || activeProducts.has(product.likut.ProductId || '')).length;
			}
			return products.filter(product => product.likut.LikutQty > 0 || product.likut.LikutPackQty > 0).length;
		}),
	);

	readonly totalHandledMekabel$ = combineLatest([this.likutMekabelDisplay$, this.isEditQuantityPopupShown$, this._likutScan.likutBarcodeScans$]).pipe(
		delay(0),
		map(([products, _, allScans]) => {
			if (allScans.length) {
				const activeProducts = new Set(allScans.map(scan => scan.productId));
				return products.filter(product => product.likut.TeudaQtyKabala > 0 || product.likut.TeudaPackQtyKabala > 0 || activeProducts.has(product.likut.ProductId || '')).length;
			}
			return products.filter(product => product.likut.TeudaQtyKabala > 0 || product.likut.TeudaPackQtyKabala > 0).length;
		}),
	);

	readonly totalHandledDisplay$ = combineLatest([this.totalHandled$, this.totalHandledMekabel$]).pipe(map(args => args.find(Boolean) || 0));

	async ngOnInit() {
		let products: any = localStorage.getItem('AllProducts') || '';

		products = JSON.parse(decompress(products)) as Product2[] | '';

		if (!products || !this.Admin) {
			// try {
			// 	if (!this.isTruckDistribution) {
			// 		throw '';
			// 	}

			// 	products = await this._idb.getAllProductsDB();

			// 	if (!products?.length) {
			// 		throw '';
			// 	}

			// 	products = products[0];
			// } catch (error) {
			localStorage.setItem('Updating', 'true');

			localStorage.removeItem('refresh');
			alert(this._text.store.missingStoredData);
			this._router.navigate(['home'], { replaceUrl: true });
			return;
			// }
		}

		this.windowVisibilityObservable$ = fromEvent(window, 'visibilitychange');
		this.windowVisibilitySubscription$ = this.windowVisibilityObservable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
			const ls = localStorage.getItem('lastupdate');
			if (ls === null) {
				this._router.navigate(['home']);
				return;
			}

			const Datetwo = JSON.parse(ls);
			const date = new Date().toISOString().slice(0, 10);

			if (Datetwo.toString().slice(0, 10) !== date) {
				this._router.navigate(['home']);
			}
		});

		window.scrollTo(0, 0);

		this._likut.refreshAllAdminTypes();
		this._barcode.updateCharacters();

		if (this.shouldConsiderBarcodeDefinitions) {
			if (this.isLikutMekabel) {
				this.relevantBarcodeDefinitions = this._likutScan.getBarcodesDefinitions(this._likut.likutMekabelOpenedState.main.rows);
			} else {
				this.relevantBarcodeDefinitions = this._likutScan.getBarcodesDefinitions(this._likut.likutOpenedNewRoutesState.sub);
			}
			console.log('Relevant Barcode Definitions\n', this.relevantBarcodeDefinitions);
		}

		this.resolveQuantityTypesParametersFromCustomerInformation();

		if (this.isLikut) {
			const mode: Parameters<typeof this.populateCheckboxState>[0] = this.isLikutMekabel ? 'likutMekabel' : 'likutNewRoutes';
			this.populateCheckboxState(mode);
		}

		// if (this.isTruckDistribution) {
		// 	this.getOrSetDisplayTask('get');
		// }

		this.populateValidQuantitiesState();

		this.handleSettingUpClientNameAndOtherText();

		if (!this.clientName) {
			this._router.navigate(['home'], { replaceUrl: true });
			return;
		}

		this.allProducts = (products as AllProducts[]).reduce((p, c) => {
			delete c.Stock;
			p[c.ProductId] = c;
			return p;
		}, {});

		this.handleForgetOriginalStock();

		await this.handleBuildStockRecord(products);

		// if (this.isNewTask || this.canAddNewItemsAsMelaket) {
		this.allProductsForAddNewProductPopup = products;
		// }

		// if (this.isTruckDistribution) {
		// 	const task = this._truckDistribution.truckDistributionOpened.task;
		// 	const allOpenedTasks = Object.values(task.teudot);

		// 	const comments = allOpenedTasks.filter(task => task.Comment).map(task => task.Comment);

		// 	if (comments.length) {
		// 		this._alert.customAlertConfirmWithoutCancel(comments);
		// 	}
		// }

		console.log(products);

		this.handleUsingRefresh();

		this.setupFormInteractivity();

		merge(this.productDisplay$, this.likutProductDisplayNewRoutes$, this.likutMekabelDisplay$)
			.pipe(
				takeUntil(this.destroy$),
				map(value => value.length),
			)
			.subscribe(this.totalShown$);

		this.totalShown$.next(this.productDisplay$.value.length || this.likutProductDisplayNewRoutes$.value.length || this.likutMekabelDisplay$.value.length);

		// TODO see if needs adjusted. maybe can add more than 1 product per task
		// if (this.canAddNewItemsAsMelaket) {
		// this.productsAlreadyAddedSet = new Set(this._likut.likutOpenedNewRoutesState.sub.map(sub => sub.ProductId));
		// }

		this.handleLikutScannerFunctionality();

		this.handleWarehousePick();
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();

		if (this.mediaStream) {
			for (const track of this.mediaStream.getTracks()) {
				this.mediaStream.removeTrack(track);
			}
		}
		if (this.video) {
			this.video.srcObject = null;
			this.video.pause();
		}

		this.normalizeCurrentlyEdittedTaskNumbers();

		clearInterval(this.intervalID);
	}

	handleSettingUpClientNameAndOtherText() {
		switch (location.pathname.split('/')[1] as SubAppModes) {
			case 'likut':
				if (this.isLikutMekabel) {
					this.clientName = this._likut.likutMekabelOpenedState.main.clientName;
					if (this.isLikutMekabelReturnTeudaType) {
						this.teudaName = this._text.store.teudaNameMekabelReturn;
					}
					break;
				}
				this.clientName = this._likut.likutOpenedNewRoutesState.task.clientName;
				break;
			// case 'truck-loading':
			// 	this.clientName = this._truckLoading.truckLoadOpened.task.clientName;
			// 	if (this._truckLoading.truckLoadOpened.task.groupB) {
			// 		this.teudaName = this._text.store.teudaNameGroupB;
			// 	}
			// 	break;
			// case 'truck-distribution':
			// 	this.clientName = this._truckDistribution.truckDistributionOpened.task.clientName;
			// 	if (this._truckDistribution.truckDistributionOpened.task.groupB) {
			// 		this.teudaName = this._text.store.teudaNameGroupB;
			// 	}
			// 	break;

			default:
				break;
		}
	}

	resolveQuantityTypesParametersFromCustomerInformation() {
		if (this.isLikut) {
			this.worksInBothSinglesAndPackQuantity = this._ss.CustomerInformation.LikutType === '0';
			this.worksInSinglesQuantity = this._ss.CustomerInformation.LikutType === '1';
			this.worksInPackQuantity = this._ss.CustomerInformation.LikutType === '2';
			if (this.isNewTask) {
				this.worksInBothSinglesAndPackQuantity = true;
				this.worksInSinglesQuantity = false;
				this.worksInPackQuantity = false;
				this.LikutType = '0';
			}
		}
	}

	async handleBuildStockRecord(products: AllProducts[]) {
		if (!this.refreshStockOnEntryAndDisplay || !this.isLikut) {
			return;
		}

		await new Promise<void>(resolve => {
			this._ss
				.RefreshMlayServiceDefault1()
				.pipe(takeUntil(this.destroy$))
				.subscribe({
					next: res => {
						if (typeof res === 'string' || !res.recordset?.length) {
							return resolve();
						}

						const stockRecord = res.recordset.reduce((p, c) => {
							p[c.it] = c;
							return p;
						}, {} as Record<string, { it: string; mly: number }>);

						for (const product of products) {
							if (stockRecord[product.ProductId]) {
								product.Stock = stockRecord[product.ProductId].mly || 0;
							}
						}

						for (const item of this._likut.likutOpenedNewRoutesState.sub) {
							if (stockRecord[item.ProductId]) {
								item.Stock = stockRecord[item.ProductId].mly || 0;
							}
						}

						for (const item of this._likut.likutMekabelOpenedState.main.rows) {
							if (stockRecord[item.ProductId]) {
								item.Stock = stockRecord[item.ProductId].mly || 0;
							}
						}

						resolve();
					},
					error: () => {
						resolve();
					},
				});
		});
	}

	handleUsingRefresh() {
		if (this.isLikut) {
			if (this._likut.isMekabel) {
				this.refreshLikutMekabelSubjects('allProductsDisplay');
				return;
			}
			this.refreshLikutNewRouteSubjects('allProductsDisplay');

			return;
		}

		// if (this.isTruckLoading) {
		// 	this.refreshSubjects('allProductsDisplay', 'truck-loading');

		// 	return;
		// }
		this.refreshSubjects('allProductsDisplay', 'truck-distribution');
	}

	refreshLikutMekabelSubjects(type: 'allProductsDisplay') {
		const productSearchValue: string = this.productSearch.value.toLowerCase();
		const len = productSearchValue.length;

		let allProducts: LikutMekabelDisplay[] = this._likut.likutMekabelOpenedState.main.rows.map(likut => ({ likut, taskIdentifier: this._likut.getLineIdentifier(likut) }));

		if (len) {
			const splitValue = productSearchValue.split(' ');

			allProducts = allProducts.map(display => {
				let counter = 0;

				const { ProductName, ProductId, Barcode } = display.likut;

				const prodNameWithoutSpaces = (ProductName || '').replace(/\s/g, '').toLowerCase(),
					productIdWithoutSpaces = (ProductId || '').replace(/\s/g, '').toLowerCase(),
					itemBarcodeWithoutSpaces = (Barcode || '').replace(/\s/g, '').toLowerCase(),
					allStrings = typeof prodNameWithoutSpaces === 'string' && typeof itemBarcodeWithoutSpaces === 'string' && typeof productIdWithoutSpaces === 'string';

				// V8 optimizes this if statement, maybe
				if (allStrings) {
					for (let j = 0; j < splitValue.length; j++) {
						if (
							(prodNameWithoutSpaces && prodNameWithoutSpaces.indexOf(splitValue[j]) > -1) ||
							(productIdWithoutSpaces && productIdWithoutSpaces.indexOf(splitValue[j]) > -1) ||
							(itemBarcodeWithoutSpaces && itemBarcodeWithoutSpaces.indexOf(splitValue[j]) > -1)
						) {
							counter++;
						}
					}

					if (counter >= splitValue.length) {
						return { ...display, matchesSearch: true };
					}
				}
				return display;
			});
		}

		if (type === 'allProductsDisplay') {
			// if (this._likut.isCheckerAgent) {
			// 	for (const display of allProducts) {
			// 		display.mismatchedQuantitiesToShowChecker = display.likut.TeudaQty !== display.likut.TeudaQtyKabala || display.likut.TeudaPackQty !== display.likut.TeudaPackQtyKabala;
			// 	}
			// }

			this.likutMekabelDisplay$.next(allProducts);
			const isAnyMatch = allProducts.filter(likut => likut.matchesSearch);
			if (isAnyMatch.length) {
				this.virtualScroll.scrollToIndex(allProducts.findIndex(display => display.likut.ProductId === isAnyMatch[0].likut.ProductId));
			}
		}
	}
	refreshLikutNewRouteSubjects(type: 'allProductsDisplay') {
		const productSearchValue: string = this.productSearch.value.toLowerCase();
		const len = productSearchValue.length;

		let allProducts: LikutProductDisplayNewRoute[] = this._likut.likutOpenedNewRoutesState.sub.map(likut => ({ product: this.allProducts[likut.ProductId], likut }));

		if (this.showEitur === null) {
			this.showEitur = allProducts.some(product => product.likut.Eitur);
		}

		if (len) {
			const splitValue = productSearchValue.split(' ');

			allProducts = allProducts.map(display => {
				let counter = 0;

				if (!display.product) return display;

				const { Product_Name, ProductId, ItemBarcode, ItemExtra1 } = display.product;

				const prodNameWithoutSpaces = (Product_Name || '').replace(/\s/g, '').toLowerCase(),
					productIdWithoutSpaces = (ProductId || '').replace(/\s/g, '').toLowerCase(),
					itemBarcodeWithoutSpaces = (ItemBarcode || '').replace(/\s/g, '').toLowerCase(),
					itemExtra1WithoutSpaces = (ItemExtra1 || '').replace(/\s/g, '').toLowerCase(),
					allStrings =
						typeof prodNameWithoutSpaces === 'string' &&
						typeof itemBarcodeWithoutSpaces === 'string' &&
						typeof itemExtra1WithoutSpaces === 'string' &&
						typeof productIdWithoutSpaces === 'string';

				// V8 optimizes this if statement, maybe
				if (allStrings) {
					for (let j = 0; j < splitValue.length; j++) {
						if (
							(prodNameWithoutSpaces && prodNameWithoutSpaces.indexOf(splitValue[j]) > -1) ||
							(productIdWithoutSpaces && productIdWithoutSpaces.indexOf(splitValue[j]) > -1) ||
							(itemBarcodeWithoutSpaces && itemBarcodeWithoutSpaces.indexOf(splitValue[j]) > -1) ||
							(itemExtra1WithoutSpaces && itemExtra1WithoutSpaces.indexOf(splitValue[j]) > -1)
						) {
							counter++;
						}
					}

					if (counter >= splitValue.length) {
						return { ...display, matchesSearch: true };
					}
				}
				return display;
			});
		}

		if (type === 'allProductsDisplay') {
			if (this._likut.isCheckerAgent) {
				for (const display of allProducts) {
					display.mismatchedQuantitiesToShowChecker = display.likut.TeudaQuantity !== display.likut.LikutQty || display.likut.TeudaPackQuantity !== display.likut.LikutPackQty;
				}
			}

			this.likutProductDisplayNewRoutes$.next(allProducts);
			const isAnyMatch = allProducts.filter(likut => likut.matchesSearch);
			if (isAnyMatch.length) {
				this.virtualScroll.scrollToIndex(allProducts.findIndex(display => display.product?.ProductId === isAnyMatch[0].product!.ProductId));
			}
		}
	}

	refreshSubjects(type: 'allProductsDisplay', mode: SubAppModes) {
		const productSearchValue: string = this.productSearch.value.toLowerCase();
		const len = productSearchValue.length;

		let allProducts: ProductDisplay[] = this.productDisplay$.value;

		if (!allProducts.length) {
			if (mode === 'truck-loading') {
				//@ts-ignore
				allProducts = this._truckLoading.truckLoadOpened.sub.map(task => {
					task.collected = false;
					return { product: this.allProducts[task.ProductID], truckTask: task };
				});
			}
			if (mode === 'truck-distribution') {
				// allProducts = this._truckDistribution.truckDistributionOpened.sub.map(task => ({ product: this.allProducts[task.ProductID], truckTask: { ...task, collected: false } }));

				//@ts-ignore
				allProducts = this._truckDistribution.truckDistributionOpened.sub.map(task => {
					task.collected = false;
					return { product: this.allProducts[task.ProductID], truckTask: task };
				});
			}
		}

		if (len) {
			const splitValue = productSearchValue.split(' ');

			allProducts = allProducts.map(display => {
				// if (!display.product) return display;

				let counter = 0;

				// const { Barcode } = display.truckTask || {};

				// const barcodeWithoutSpaces = (Barcode || '').replace(/\s/g, '').toLowerCase(),
				// 	allStrings = typeof barcodeWithoutSpaces === 'string';

				// V8 optimizes this if statement, maybe
				// if (allStrings) {
				// 	for (let j = 0; j < splitValue.length; j++) {
				// 		if (barcodeWithoutSpaces && barcodeWithoutSpaces.indexOf(splitValue[j]) > -1) {
				// 			counter++;
				// 		}
				// 	}

				// 	if (counter >= splitValue.length) {
				// 		console.log(display);
				// 		display.matchesSearch = true;
				// 		return display;
				// 	}
				// }
				display.matchesSearch = false;
				return display;
			});
		} else {
			for (const product of allProducts) {
				product.matchesSearch = false;
			}
		}
	}

	handlePopupOpen(task: ProductDisplayLikutOrTruck | LikutMekabelDisplay) {
		if (this.isProductWithLikutMekabel(task)) {
			this.handleLikutMekabelPopupOpen(task);
			return;
		}
		if (
			// (!this._likut.isMelaketAgent && !this._likut.isCheckerAgentAndCanEdit && !this.isTruckDistribution) ||
			!task.product
			//  || this._truckLoading.isNahagAndCantChangeQuantities
		) {
			return;
		}

		this.currentlyEdittedTask = task;

		if (this.isProductWithLikut(task)) {
			task.opened = true;
			this.currentlyEdittedLikutTask$.next(task);
			this._likutScan.refreshFilter(task.likut);
		}

		this.form.controls.collected.reset();
		this.form.controls.collectedPacks.reset();
		this.form.controls.price.reset();

		this.showHideProductDetailPopup(true);

		// setTimeout(() => {
		// 	if (this.isLikutScannerActive) return
		// 	if (this.collectedInput) {
		// 		this.collectedInput.nativeElement.focus();
		// 		return;
		// 	}
		// 	if (this.collectedPacksInput) {
		// 		this.collectedPacksInput.nativeElement.focus();
		// 	}
		// }, 0);
	}

	handleLikutMekabelPopupOpen(task: LikutMekabelDisplay) {
		task.opened = true;
		this.currentlyEdittedTaskLikutMekabel = task;
		this.currentlyEdittedLikutMekabelTask$.next(task);

		this._likutScan.refreshFilter(task.likut);

		this.form.controls.collected.reset();
		this.form.controls.collectedPacks.reset();
		// this.form.controls.price.reset();

		this.showHideProductDetailPopup(true);

		setTimeout(() => {
			this.collectedInput.nativeElement.focus();
		}, 0);
	}

	handlePopupClose() {
		this.normalizeCurrentlyEdittedTaskNumbers();
		this.currentlyEdittedTask = this.currentlyEdittedTaskLikutMekabel = null;
		this.currentlyEdittedLikutTask$.next(null);
		this.currentlyEdittedLikutMekabelTask$.next(null);

		this.form.reset();
		this._likutScan.resetFilter();

		this.showHideProductDetailPopup(false);
	}

	showHideProductDetailPopup(value: boolean): void {
		this.isEditQuantityPopupShown$.next(value);
	}

	handleQuantityButtonPress(action: 'increment' | 'decrement', quantity: 'single' | 'pack' = 'single') {
		// if (!('likut' in this.currentlyEdittedTask)) return;
		if (!this.worksInBothSinglesAndPackQuantity && !this.isNewTask) {
			quantity = this.worksInSinglesQuantity ? 'single' : 'pack';
		}
		this.handleQuantityIncrementOrDecrement(action, quantity);

		this.getOrSetDisplayTask('set', this.productDisplay$.value);

		const { collected, collectedPacks, docID, itemID, packs, singles } = this.getCollectedInCurrentlyEdittedProduct();

		const totalQuantity = this.getTotalQuantityOfCurrentlyEdittedTask();

		const mode: Parameters<typeof getLineIdentifier>[0]['mode'] = this.pageMode$.value;

		let identifier = '';
		if (this.isProductWithLikut(this.currentlyEdittedTask)) {
			identifier = getLineIdentifier({ mode: mode as 'likut', task: this.currentlyEdittedTask.likut });
			this.likutProductDisplayNewRoutes$.next(this.likutProductDisplayNewRoutes$.value);
		}

		if (this.isLikutMekabel) {
			identifier = getLineIdentifier({ mode: mode as 'likut-mekabel', task: this.currentlyEdittedTaskLikutMekabel.likut });
			this.likutMekabelDisplay$.next(this.likutMekabelDisplay$.value);
		}

		if (!this.handleChangeValidityColor({ collected, collectedPacks, lineIdentifier: identifier, packs, singles, totalQuantity })) {
			return;
		}

		// TODO What about collectedPAcks?
		const { collected: collectedValue, collectedPacks: collectedPacksValue } = this.form.value;

		// this.checkboxState[identifier] = +collectedValue + +collectedPacksValue === totalQuantity;

		// console.log(this.productDisplay$.value);
		// this._change.detectChanges();
		// return;
	}

	getTotalQuantityOfCurrentlyEdittedTask(): number {
		const { singles, packs } = this.getSinglesAndPacksInCurrentlyEdittedProduct();

		let totalQuantity = 0;

		if (this.worksInPackQuantity || this.worksInBothSinglesAndPackQuantity) {
			totalQuantity += +packs;
		}

		if (this.worksInSinglesQuantity || this.worksInBothSinglesAndPackQuantity) {
			totalQuantity += +singles;
		}

		return totalQuantity;
	}

	handleChangeValidityColor(quantities: { singles: number; packs: number; lineIdentifier: string; collected: number; collectedPacks: number; totalQuantity: number }): boolean {
		const { singles, packs, collected, collectedPacks, lineIdentifier, totalQuantity } = quantities;

		if (this.isLikutMekabel) {
			this.validQuantitiesState[lineIdentifier] = (+this.form.controls.collected.value || collected) === +singles && (+this.form.controls.collectedPacks.value || collectedPacks) === +packs;

			// this.checkboxState[lineIdentifier] = (+this.form.controls.collected.value || collected) === +singles && (+this.form.controls.collectedPacks.value || collectedPacks) === +packs;
			return false;
		}

		if (this.worksInBothSinglesAndPackQuantity) {
			this.validQuantitiesState[lineIdentifier] = (+this.form.controls.collected.value || collected) === +singles && (+this.form.controls.collectedPacks.value || collectedPacks) === +packs;
			if (this._likut.isCheckerAgent) {
				if ('mismatchedQuantitiesToShowChecker' in this.currentlyEdittedTask) {
					this.currentlyEdittedTask.mismatchedQuantitiesToShowChecker = !this.validQuantitiesState[lineIdentifier];
					this.likutProductDisplayNewRoutes$.next([...this.likutProductDisplayNewRoutes$.value]);
				}
				return false;
			}
			// this.checkboxState[lineIdentifier] = (+this.form.controls.collected.value || collected) === +singles && (+this.form.controls.collectedPacks.value || collectedPacks) === +packs;
			return false;
		}

		this.validQuantitiesState[lineIdentifier] = this.form.controls.collected.value === totalQuantity;
		if (this._likut.isCheckerAgent) {
			if ('mismatchedQuantitiesToShowChecker' in this.currentlyEdittedTask) {
				this.currentlyEdittedTask.mismatchedQuantitiesToShowChecker = !this.validQuantitiesState[lineIdentifier];
			}
			return false;
		}

		return true;
	}

	handleQuantityIncrementOrDecrement(action: 'increment' | 'decrement', quantity: 'single' | 'pack') {
		const { taskObject, taskCollectedProperty, totalQuantityCollected, totalQuantityOrdered } = this.resolveTaskQuantityParameters({ quantity });

		const canIncrement = true;

		if (action === 'increment') {
			if (canIncrement) {
				taskObject[taskCollectedProperty]++;
			}
			this.form.controls[quantity === 'single' ? 'collected' : 'collectedPacks'].setValue(taskObject[taskCollectedProperty]);
		}

		if (action === 'decrement') {
			taskObject[taskCollectedProperty] = Math.max(totalQuantityCollected - 1, 0);
			this.form.controls[quantity === 'single' ? 'collected' : 'collectedPacks'].setValue(taskObject[taskCollectedProperty]);
		}
	}

	resolveTaskQuantityParameters(options: { quantity: 'single' | 'pack' }) {
		let totalQuantityOrdered = 0,
			totalQuantityCollected = 0,
			taskObject = {},
			taskQuantityProperty = '',
			taskCollectedProperty = '';

		const { quantity } = options;

		if (this.isProductWithLikut(this.currentlyEdittedTask)) {
			taskObject = this.currentlyEdittedTask.likut;

			taskQuantityProperty = quantity === 'single' ? 'TeudaQuantity' : 'TeudaPackQuantity';
			taskCollectedProperty = quantity === 'single' ? 'LikutQty' : 'LikutPackQty';
		}

		if (this.isLikutMekabel) {
			taskObject = this.currentlyEdittedTaskLikutMekabel.likut;
			taskQuantityProperty = quantity === 'single' ? 'TeudaQty' : 'TeudaPackQty';
			taskCollectedProperty = quantity === 'single' ? 'TeudaQtyKabala' : 'TeudaPackQtyKabala';
		}

		totalQuantityOrdered = taskObject[taskQuantityProperty];
		totalQuantityCollected = taskObject[taskCollectedProperty];

		return { totalQuantityOrdered, totalQuantityCollected, taskObject, taskQuantityProperty, taskCollectedProperty };
	}

	handleIfBackspaceOnEmptyInput(e: Event) {
		if (!(e instanceof KeyboardEvent) || ['.', 'Backspace'].includes(e.key)) return;

		const inputs = [
			{ input: this.collectedInput, control: 'collected' },
			{ input: this.collectedPacksInput, control: 'collectedPacks' },
			{ input: this.priceInput, control: 'price' },
			{ input: this.discountInput, control: 'discount' },
		];

		inputs.forEach(({ input, control }) => {
			if (!input?.nativeElement) return;
			if (e.target === input.nativeElement && this.form.controls[control].value === null) {
				this.form.controls[control].setValue(0);
			}
		});
	}

	async handleCheckboxPress(line: ProductDisplay | LikutProductDisplayNewRoute) {
		if (this.isLikut && 'likut' in line) {
			line.opened = true;
			if (!line.product) return;

			this.likutProductDisplayNewRoutes$.next([...this.likutProductDisplayNewRoutes$.value]);

			const identifier = getLineIdentifier({ mode: 'likut', task: line.likut });

			const state = this.checkboxState[identifier];
			if (this._likut.isCheckerAgent) {
				// this.checkboxState[identifier] = !state;
				this._change.detectChanges();
				return;
			}
			const likutProduct = this._likut.likutOpenedNewRoutesState.sub.find(likut => likut.TeudaNum === line.likut.TeudaNum && likut.TeudaLineNum === line.likut.TeudaLineNum);

			if (likutProduct) {
				const scansDictionary = this._likutScan.buildScanDictionary();
				if (scansDictionary[this._likutScan.getTaskIdentifierForScan(likutProduct)]) {
					const confirmation = await this._alert.customConfirmAlert(`האם אתה בטוח שברצונך לבטל את כל סריקות המוצר ${line.product.Product_Name}?`);
					if (!confirmation) {
						line.opened = false;
						this.checkboxState[identifier] = false;
						this.likutProductDisplayNewRoutes$.next([...this.likutProductDisplayNewRoutes$.value]);
						return;
					}
					this._likutScan.clearItemFromScanHistory(likutProduct);
				}

				if (this.worksInBothSinglesAndPackQuantity || this.worksInSinglesQuantity) {
					likutProduct.LikutQty = state ? 0 : line.likut.TeudaQuantity;
					line.likut.LikutQty = likutProduct.LikutQty;
				}

				if (this.worksInBothSinglesAndPackQuantity || this.worksInPackQuantity) {
					likutProduct.LikutPackQty = state ? 0 : line.likut.TeudaPackQuantity;
					line.likut.LikutPackQty = likutProduct.LikutPackQty;
				}

				this.likutProductDisplayNewRoutes$.next([...this.likutProductDisplayNewRoutes$.value]);

				// this._change.detectChanges();
			} else {
				console.log('i should never show');
			}
		}
	}

	async handleCheckboxPressLikutMekabel(line: LikutMekabelDisplay) {
		line.opened = true;

		const lineIdentifier = getLineIdentifier({ mode: 'likut-mekabel', task: line.likut });
		const newCheckState = !this.checkboxState[lineIdentifier];

		const likutProduct = this._likut.likutMekabelOpenedState.main.rows.find(likut => likut.TeudaNum === line.likut.TeudaNum && likut.TeudaLineNum === line.likut.TeudaLineNum);

		if (likutProduct) {
			const scansDictionary = this._likutScan.buildScanDictionary();
			if (scansDictionary[this._likutScan.getTaskIdentifierForScan(likutProduct)]) {
				const confirmation = await this._alert.customConfirmAlert(`האם אתה בטוח שברצונך לבטל את כל סריקות המוצר ${line.likut.ProductName}?`);
				if (!confirmation) {
					line.opened = false;
					this.checkboxState[lineIdentifier] = false;
					this.likutMekabelDisplay$.next([...this.likutMekabelDisplay$.value]);
					this._change.markForCheck();
					return;
				}
				this._likutScan.clearItemFromScanHistory(likutProduct);
			}

			if (this.worksInBothSinglesAndPackQuantity || this.worksInSinglesQuantity) {
				likutProduct.TeudaQtyKabala = newCheckState ? line.likut.TeudaQty : 0;
				line.likut.TeudaQtyKabala = likutProduct.TeudaQtyKabala;
			}

			if (this.worksInBothSinglesAndPackQuantity || this.worksInPackQuantity) {
				likutProduct.TeudaPackQtyKabala = newCheckState ? line.likut.TeudaPackQty : 0;
				line.likut.TeudaPackQtyKabala = likutProduct.TeudaPackQtyKabala;
			}

			// this.likutProductDisplayNewRoutes$.next([...this.likutProductDisplayNewRoutes$.value]);

			// this._change.detectChanges();
			this.likutMekabelDisplay$.next([...this.likutMekabelDisplay$.value]);
		} else {
			console.log('i should never show');
		}

		// if (this.worksInBothSinglesAndPackQuantity || this.worksInSinglesQuantity) {
		// 	line.likut.TeudaQtyKabala = newCheckState ? line.likut.TeudaQty : 0;
		// }

		// if (this.worksInBothSinglesAndPackQuantity || this.worksInPackQuantity) {
		// 	line.likut.TeudaPackQtyKabala = newCheckState ? line.likut.TeudaPackQty : 0;
		// }

		// const { TeudaQty: singles, TeudaPackQty: packs, TeudaQtyKabala: collected, TeudaPackQtyKabala: collectedPacks } = line.likut;

		// this.handleChangeValidityColor({ collected, collectedPacks, lineIdentifier, packs, singles, totalQuantity: 0 });

		// this.likutMekabelDisplay$.next(this.likutMekabelDisplay$.value);
	}

	async moveToFinishTask() {
		const subPath = this.pageMode$.value;

		// if (
		// 	!this._likut.isCheckerAgent
		// 	// && !this.isTruckLoading
		// ) {
		// if (this.isTruckDistribution) {
		// this._loading.changeLoadingStatuses({ isLoading: true });
		// }
		if (this.isLikutMekabel) {
			if (!this.likutMekabelDisplay$.value.length) {
				alert('לא ניתן לסיים משימה ללא מוצרים');
				return;
			}
			if (this.isNewTask) {
				this._router.navigate(['likut', 'finish', 'mekabel'], { queryParams: { new: true } });
				return;
			}
			if (this.isLikutMekabelReturnTeudaType) {
				// all products with quantities must have warehouse selected
				// const rowsWithQuantities = [];
			}
			this._router.navigate(['likut', 'finish', 'mekabel']);
			return;
		}
		this._router.navigate([subPath, 'finish', 'sfira']);
		return;
		// }

		// let uncheckedItem = Object.entries(this.checkboxState).find(([_, state]) => !state);

		// let array: LikutSubSQL[];
		// let array: (LikutSubSQL | TruckLoadingSubSQL)[];

		// if (this.isLikut) {
		// 	array = this._likut.likutOpenedNewRoutesState.sub.filter(sub => this.allProducts[sub.ProductId]);
		// 	uncheckedItem = Object.entries(this.checkboxState).find(([productid, state]) => !state && this.allProducts[productid.split(' - ')[0]]);
		// }

		// if (this.isTruckLoading) {
		// 	array = this._truckLoading.truckLoadOpened.sub;
		// }

		// if (uncheckedItem || !Object.entries(this.checkboxState).length || Object.entries(this.checkboxState).length !== array.length) {
		// 	if (this.isLikut && !this.isLocal) {
		// 		alert(this._text.store.cantFinishAlert);
		// 		if (uncheckedItem) {
		// 			this.virtualScroll.scrollToIndex(this.likutProductDisplayNewRoutes$.value.findIndex(prod => prod.product.ProductId === uncheckedItem[0].split(' - ')[0]));
		// 		}
		// 		return;
		// 	}
		// }

		this._router.navigate([subPath, 'finish']);
	}

	SearchClear() {
		this.productSearch.reset();
	}

	handleBarcodePopupOpen() {
		this.isBarcodePopupOpen$.next(true);

		setTimeout(() => {
			try {
				if (this.videoElement && this.videoElement.nativeElement) {
					this.video = this.videoElement.nativeElement;
				} else {
					alert('no video element');
					throw new Error();
				}
				if (!window.BarcodeDetector) {
					alert(this._text.store.barcodeError.unsupported);
					throw new Error();
				}

				if (!navigator.mediaDevices || !('getUserMedia' in navigator.mediaDevices)) {
					alert('אין גישה למצלמה');
					throw new Error();
				}
			} catch (error) {
				this.handleBarcodePopupClose();
				return;
			}

			const constraints: MediaStreamConstraints = {
				video: { facingMode: { exact: 'environment' } },
				audio: false,
			};

			navigator.mediaDevices
				.getUserMedia(constraints)
				.then(async stream => {
					this.video.srcObject = stream;
					this.video.play();

					this.mediaStream = stream;

					const formats: SupportedFormats[] = ['code_39', 'codabar', 'ean_13', 'code_128'];

					const barcodeFormatsDetect = new window.BarcodeDetector({ formats });

					if (!barcodeFormatsDetect) {
						alert(this._text.store.barcodeError.unsupported);
						return;
					}

					const barcodeDetector = new window.BarcodeDetector({ formats });

					const detectCode = async () => {
						if (!('detect' in barcodeDetector) || !this.video || this.video.paused) {
							return;
						}

						if (this.detectedCode?.length) {
							return;
						}

						try {
							const codes = await barcodeDetector.detect(this.video);
							if (!codes?.length) return;

							for (const barcode of codes) {
								this.productSearch.reset();
								this.addProductFormControl.reset();
								if (this.isAddNewProductForMekabelPopupOpen$.value && !this.detectedCode?.length) {
									const prod = this.allProductsForAddNewProductPopup.find(prod => prod.ItemBarcode === barcode.rawValue);
									if (prod) {
										this.addProductFormControl.reset();
										this.detectedCode = barcode.rawValue;

										if (this.isNewTask) {
											const display = this.handleAddNewProductToTaskForMekabel(prod);
											this.handleAddSelectedProductForMekabel(display);
										} else {
											const display = this.handleAddNewProductToTaskForMelaket(prod);
											this.handleAddSelectedProductForMelaket(display);
										}

										this.refreshBarcodeDefinitions();
										this.handleBarcodePopupClose();

										return;
									}
									this.openSnackbarForNoBarcode(barcode.rawValue);
									return;
								}
								if (!this.detectedCode?.length) {
									this.handleScrollToProductIfExist(barcode.rawValue);
								}
								this.detectedCode = barcode.rawValue;
							}
						} catch (error) {
							console.error(error);
						}

						this.handleBarcodePopupClose();
					};

					this.intervalID = setInterval(detectCode, 200);
				})
				.catch(() => {
					this.supportsVideo = false;
					alert(this._text.store.barcodeError.needsCameraAccess);
					this.handleBarcodePopupClose();
				});
		}, 0);
	}

	handleBarcodePopupClose() {
		if (this.mediaStream) {
			for (const track of this.mediaStream.getTracks()) {
				this.mediaStream.removeTrack(track);
			}
		}
		if (this.video) {
			this.video.srcObject = null;
			this.video.pause();
		}

		clearInterval(this.intervalID);

		this.detectedCode = '';

		this.isBarcodePopupOpen$.next(false);
	}

	async handleSendLikutBackToMelaket() {
		try {
			this._alert.customAlert(this._text.store.processSuccessful[0]);
			this.isCheckerReturnPopupOpen$.next(false);
			this.handleMelaketGoBack();
		} catch (error) {
			alert(this._text.store.couldntPatch);
		}
	}

	async handleMelaketGoBack(destination: 'back' | 'home' = 'back') {
		try {
			try {
				await this.handleChangeOpenedBy();
			} catch (error) {
				// if (!this.isTruckDistribution)
				throw error;
			}
			// if (this.isTruckLoading) {
			// 	this._truckLoading.resetTruckLoadingState();
			// }

			// if (this.isTruckDistribution) {
			// 	this._truckDistribution.resetTruckDistributionState();
			// }
			if (this.isLikut) {
				this._likut.resetLikutState();
			}
			if (destination === 'back') {
				history.back();
				return;
			}
			if (destination === 'home') {
				this._router.navigate(['home'], { replaceUrl: true });
				return;
			}
		} catch (error) {
			alert(this._text.store.taskConnectionError);
		}
	}

	handleDeveloperCheckAll() {
		if (this._likut.isCheckerAgent) {
			this.checkboxState = this._likut.likutOpenedNewRoutesState.sub.reduce((p, c) => {
				const identifier = getLineIdentifier({ mode: 'likut', task: c });
				p[identifier] = true;

				return p;
			}, {});
			return;
		}
		for (const product in this.checkboxState) {
			this.checkboxState[product] = true;
		}
	}

	async handleChangeOpenedBy(): Promise<void> {
		if (this.isLikutMekabel || this.isDevelopment) return;
		if (this.isLikut) {
			return await new Promise((resolve, reject) => {
				const teudaNums = [...new Set(this._likut.likutOpenedNewRoutesState.sub.map(likut => likut.TeudaNum))];
				this._ss
					.getLikutByTeudaNumMain(teudaNums, 'freeup')
					.pipe(takeUntil(this.destroy$))
					.subscribe({
						next: res => {
							if (typeof res === 'string') {
								return reject();
							}
							resolve();
						},
						error: () => {
							reject();
						},
					});
			});
		}
	}

	setupFormInteractivity() {
		this.form.controls.collected.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
			next: value => {
				if (value === null) return;

				if (+value < 0 || isNaN(+value)) {
					this.form.controls.collected.reset();
				}

				const { singles, packs } = this.getSinglesAndPacksInCurrentlyEdittedProduct();

				if (+value > singles && !this.canGoAboveOriginalQuantity) {
					this.form.controls.collected.reset(singles);
				}

				this.syncTaskQuantityWithForm({ quantity: this.worksInBothSinglesAndPackQuantity || this.worksInSinglesQuantity ? 'single' : 'pack' });

				const { collected, collectedPacks } = this.getCollectedInCurrentlyEdittedProduct();
				const totalQuantity = this.getTotalQuantityOfCurrentlyEdittedTask();

				let lineIdentifier = '';

				if (this.isProductWithLikut(this.currentlyEdittedTask)) {
					const modeTyped = 'likut';
					lineIdentifier = getLineIdentifier({ mode: modeTyped, task: this.currentlyEdittedTask.likut });
				}

				if (this.isLikutMekabel) {
					const modeTyped = 'likut-mekabel';
					lineIdentifier = getLineIdentifier({ mode: modeTyped, task: this.currentlyEdittedTaskLikutMekabel.likut });
				}

				this.handleChangeValidityColor({ lineIdentifier, collected, collectedPacks, packs, singles, totalQuantity });

				// if (this.isTruckDistribution) {
				// 	this.getOrSetDisplayTask('set', this.productDisplay$.value);
				// }
			},
		});
		this.form.controls.collectedPacks.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
			next: value => {
				if (value === null) return;

				if (+value < 0 || isNaN(+value)) {
					this.form.controls.collectedPacks.reset();
				}

				const { singles, packs } = this.getSinglesAndPacksInCurrentlyEdittedProduct();

				if (+value > packs && !this.canGoAboveOriginalQuantity) {
					this.form.controls.collectedPacks.reset(packs);
				}

				this.syncTaskQuantityWithForm({ quantity: 'pack' });

				const { itemID, collected, collectedPacks, docID } = this.getCollectedInCurrentlyEdittedProduct();
				const totalQuantity = this.getTotalQuantityOfCurrentlyEdittedTask();

				let lineIdentifier = '';

				if (this.isProductWithLikut(this.currentlyEdittedTask)) {
					const modeTyped = 'likut';
					lineIdentifier = getLineIdentifier({ mode: modeTyped, task: this.currentlyEdittedTask.likut });
				}

				if (this.isLikutMekabel) {
					const modeTyped = 'likut-mekabel';
					lineIdentifier = getLineIdentifier({ mode: modeTyped, task: this.currentlyEdittedTaskLikutMekabel.likut });
				}

				this.handleChangeValidityColor({ collected, collectedPacks, lineIdentifier, packs, singles, totalQuantity });

				// if (this.isTruckDistribution) {
				// 	this.getOrSetDisplayTask('set', this.productDisplay$.value);
				// }
			},
		});
		this.form.controls.price.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
			next: value => {
				if (!this.isLikutMekabel && (value === null || !this._likut.isCheckerAgentAndCanEdit)) return;

				if (+value < 0 || isNaN(+value)) {
					this.form.controls.price.reset(0);
				}

				if (+value > MAX_PRODUCT_PRICE) {
					this.form.controls.price.reset(MAX_PRODUCT_PRICE);
				}

				if (this.isProductWithLikut(this.currentlyEdittedTask)) {
					this.currentlyEdittedTask.likut.LikutPrice = +this.form.controls.price.value || 0;
				}

				if (this.isProductWithLikutMekabel(this.currentlyEdittedTaskLikutMekabel)) {
					this.currentlyEdittedTaskLikutMekabel.likut.PriceOut = +this.form.controls.price.value || 0;
				}
			},
		});

		this.form.controls.discount.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
			next: value => {
				if (+value < 0 || isNaN(+value)) {
					this.form.controls.discount.reset();
				}

				if (+value > MAX_DISCOUNT) {
					this.form.controls.discount.reset(MAX_DISCOUNT);
				}

				if (this.isProductWithLikutMekabel(this.currentlyEdittedTaskLikutMekabel)) {
					this.currentlyEdittedTaskLikutMekabel.likut.DiscountOut = +this.form.controls.discount.value || 0;
				}
			},
		});

		this.form.controls.eitur.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
			next: value => {
				if (value === null) return;

				if (value.includes('*')) {
					this.form.controls.eitur.reset(value.replace('*', ''));
					return;
				}

				if (value.length > 100) {
					this.form.controls.eitur.reset(value.slice(0, 100));
				}

				if (this.isProductWithLikutMekabel(this.currentlyEdittedTaskLikutMekabel)) {
					this.currentlyEdittedTaskLikutMekabel.likut.Eitur = this.form.controls.eitur.value || '';
				}
				if (this.isProductWithLikut(this.currentlyEdittedTask)) {
					this.currentlyEdittedTask.likut.Eitur = this.form.controls.eitur.value || '';
				}
			},
		});

		this.form.controls.remark.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
			next: value => {
				if (value === null) return;

				if (value.includes('*')) {
					this.form.controls.remark.reset(value.replace('*', ''));
					return;
				}
				if (value.length > 100) {
					this.form.controls.remark.reset(value.slice(0, 100));
				}

				if (this.isProductWithLikutMekabel(this.currentlyEdittedTaskLikutMekabel)) {
					this.currentlyEdittedTaskLikutMekabel.likut.ItemRemark = this.form.controls.remark.value || '';
				}
			},
		});

		this.productSearch.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.handleUsingRefresh();
		});

		// if (this.isTruckDistribution) {
		// 	this.productDisplay$.pipe(takeUntil(this.destroy$)).subscribe(val => {
		// 		this.getOrSetDisplayTask('set', val);
		// 	});
		// }

		// if (this.isNewTask || this.canAddNewItemsAsMelaket) {
		this.addProductSearch$ = this.addProductFormControl.valueChanges.pipe(
			startWith(''),
			map(value => {
				const name = value;
				return name ? this._filterProduct(name as string) : this.allProductsForAddNewProductPopup.filter(prod => !this.productsAlreadyAddedSet.has(prod.ProductId)).slice(0, 50);
			}),
		);
		// }
	}

	syncTaskQuantityWithForm(options: { quantity: 'single' | 'pack' }) {
		if (options.quantity === 'single') {
			if (this.isProductWithLikut(this.currentlyEdittedTask)) {
				this.currentlyEdittedTask.likut.LikutQty = +this.form.controls.collected.value;
				this._change.detectChanges();
				return;
			}

			if (this.isLikutMekabel) {
				this.currentlyEdittedTaskLikutMekabel.likut.TeudaQtyKabala = +this.form.controls.collected.value;
			}
		}

		if (options.quantity === 'pack') {
			if (this.isProductWithLikut(this.currentlyEdittedTask)) {
				this.currentlyEdittedTask.likut.LikutPackQty = +this.form.controls.collectedPacks.value;
				return;
			}

			if (this.isLikutMekabel) {
				this.currentlyEdittedTaskLikutMekabel.likut.TeudaPackQtyKabala = +this.form.controls.collectedPacks.value;
			}
		}
	}

	handleScrollToProductIfExist(productBarcode: string) {
		let productIndex = -1;
		// let productIndex = this.productDisplay$.value.findIndex(task => task.truckTask.Barcode === productBarcode);

		if (this.isLikut) {
			productIndex = this.likutProductDisplayNewRoutes$.value.findIndex(product => product.product?.ItemBarcode === productBarcode);
		}

		if (this.isLikutMekabel) {
			productIndex = this.likutMekabelDisplay$.value.findIndex(product => product.likut.Barcode === productBarcode);
		}

		if (productIndex > -1) {
			this.virtualScroll.scrollToIndex(productIndex, 'smooth');

			if (this.isLikut && this._ss.CustomerInformation.LikutSearch === '1') {
				if (this.isLikutMekabel) {
					const prod = this.likutMekabelDisplay$.value[productIndex];
					if (!prod) return;
					const likut = this._likut.likutMekabelOpenedState.main.rows.find(line => line.ProductId === prod.likut.ProductId);
					if (likut) {
						likut.TeudaQtyKabala = likut.TeudaQty;
						likut.TeudaPackQtyKabala = likut.TeudaPackQty;
						const identifier = getLineIdentifier({ mode: 'likut-mekabel', task: likut });
						this.checkboxState[identifier] = true;
					}
					return;
				}
				const prod = this.likutProductDisplayNewRoutes$.value[productIndex];

				if (!prod) return;

				const likut = this._likut.likutOpenedNewRoutesState.sub.find(line => line.ProductId === prod.product.ProductId);

				if (likut) {
					likut.LikutQty = likut.TeudaQuantity;
					likut.LikutPackQty = likut.TeudaPackQuantity;
					const identifier = getLineIdentifier({ mode: 'likut', task: likut });
					this.checkboxState[identifier] = true;
				}
			}
			return;
		}

		this.openSnackbarForNoBarcode(productBarcode);
	}

	openSnackbarForNoBarcode(barcode: string) {
		this._bottomPopup.show(`${this._text.store.barcodeNotFound[0]} ${barcode} ${this._text.store.barcodeNotFound[1]}`, { action: '' });
	}

	openSnackbarForDuplicatePackageID() {
		this._bottomPopup.show(`לא ניתן להוסיף אריזה זאת שוב`);
	}

	openSnackbarForAlreadyCheckedAndCannotBeScanned() {
		this._bottomPopup.show(`לא ניתן לסרוק פריט זה כעת`);
	}

	populateCheckboxState(mode: 'truckLoading' | 'likutNewRoutes' | 'likutMekabel') {
		// this.likutMekabelDisplay$.next([...this.likutMekabelDisplay$.value]);
		// this.likutProductDisplayNewRoutes$.next([...this.likutProductDisplayNewRoutes$.value]);
		if (this._likut.isCheckerAgent) return;

		// if (mode === 'likutNewRoutes') {
		// 	this.checkboxState = this._likut.likutOpenedNewRoutesState.sub.reduce((p, c) => {
		// 		// let isQuantityCollected = false;
		// 		const singles = c.TeudaPackQuantity === c.LikutPackQty,
		// 			packs = c.TeudaQuantity === c.LikutQty,
		// 			identifier = getLineIdentifier({ mode: 'likut', task: c });

		// 		if (this.worksInPackQuantity) {
		// 			p[identifier] = packs;
		// 		}

		// 		if (this.worksInSinglesQuantity) {
		// 			p[identifier] = singles;
		// 		}

		// 		if (this.worksInBothSinglesAndPackQuantity) {
		// 			p[identifier] = singles && packs;
		// 		}

		// 		return p;
		// 	}, {});
		// }
		// if (mode === 'likutMekabel') {
		// 	this.checkboxState = this._likut.likutMekabelOpenedState.main.rows.reduce((p, c) => {
		// 		const packs = c.TeudaPackQty === c.TeudaPackQtyKabala,
		// 			singles = c.TeudaQtyKabala === c.TeudaQty,
		// 			identifier = getLineIdentifier({ mode: 'likut-mekabel', task: c });

		// 		if (this.worksInPackQuantity) {
		// 			p[identifier] = packs;
		// 		}

		// 		if (this.worksInSinglesQuantity) {
		// 			p[identifier] = singles;
		// 		}

		// 		if (this.worksInBothSinglesAndPackQuantity) {
		// 			p[identifier] = singles && packs;
		// 		}

		// 		return p;
		// 	}, {});
		// }
	}

	populateValidQuantitiesState() {
		// if (this.isTruckLoading) return;

		// if (this.isTruckDistribution) {
		// 	this.validQuantitiesState = this._truckDistribution.truckDistributionOpened.sub.reduce((p, c) => {
		// 		let isQuantityCollected = false;
		// 		if (this.worksInBothSinglesAndPackQuantity) {
		// 			isQuantityCollected = c.Quantity === c.PODQuantity && c.PackQTY === c.PODPackQTY;
		// 		}
		// 		if (this.worksInPackQuantity) {
		// 			isQuantityCollected = c.PackQTY === c.PODPackQTY;
		// 		}
		// 		if (this.worksInSinglesQuantity) {
		// 			isQuantityCollected = c.Quantity === c.PODQuantity;
		// 		}

		// 		const identifier = getLineIdentifier({ mode: 'truck-distribution', task: c });

		// 		p[identifier] = isQuantityCollected;

		// 		return p;
		// 	}, {});

		// 	return;
		// }

		if (this.isLikutMekabel) {
			this.validQuantitiesState = this._likut.likutMekabelOpenedState.main.rows.reduce((p, c) => {
				const packs = c.TeudaPackQty === c.TeudaPackQtyKabala,
					singles = c.TeudaQtyKabala === c.TeudaQty,
					identifier = getLineIdentifier({ mode: 'likut-mekabel', task: c });
				if (this.worksInBothSinglesAndPackQuantity) {
					p[identifier] = packs && singles;
				}
				if (this.worksInPackQuantity) {
					p[identifier] = packs;
				}
				if (this.worksInSinglesQuantity) {
					p[identifier] = singles;
				}

				return p;
			}, {});

			return;
		}

		this.validQuantitiesState = this._likut.likutOpenedNewRoutesState.sub.reduce((p, c) => {
			let isQuantityCollected = false;
			if (this.worksInBothSinglesAndPackQuantity) {
				isQuantityCollected = c.LikutQty === c.TeudaQuantity && c.LikutPackQty === c.TeudaPackQuantity;
			}
			if (this.worksInPackQuantity) {
				isQuantityCollected = c.LikutPackQty === c.TeudaPackQuantity;
			}
			if (this.worksInSinglesQuantity) {
				isQuantityCollected = c.LikutQty === c.TeudaQuantity;
			}

			const identifier = getLineIdentifier({ mode: 'likut', task: c });

			p[identifier] = isQuantityCollected;

			return p;
		}, {});
	}

	handlePressEnterOnSearch(e?: KeyboardEvent) {
		if (e.key !== 'Enter') return;

		let relevantProducts: (ProductDisplay | LikutProductDisplayNewRoute)[] = this.productDisplay$.value.filter(f => f.matchesSearch);

		if (this.isLikut && !relevantProducts.length) {
			relevantProducts = this.likutProductDisplayNewRoutes$.value.filter(f => f.matchesSearch);
			// handle likutmekabel
		}

		if (relevantProducts.length === 1) {
			const prod = relevantProducts[0];

			if (this.isLikut && 'likut' in prod) {
				const likut = this._likut.likutOpenedNewRoutesState.sub.find(opened => opened.ProductId === prod.product?.ProductId);
				if (likut && !this._likut.isCheckerAgent && this._ss.CustomerInformation.LikutSearch === '1') {
					const identifier = getLineIdentifier({ mode: 'likut', task: likut });
					this.checkboxState[identifier] = true;

					prod.opened = true;

					likut.LikutQty = likut.TeudaQuantity;
					likut.LikutPackQty = likut.TeudaPackQuantity;
				}
			}
		}
	}

	getSinglesAndPacksInCurrentlyEdittedProduct(): { singles: number; packs: number } {
		const singles = 0,
			packs = 0;

		if (this.isLikutMekabel) {
			return { singles: this.currentlyEdittedTaskLikutMekabel.likut.TeudaQty, packs: this.currentlyEdittedTaskLikutMekabel.likut.TeudaPackQty };
		}

		if (this.isProductWithLikut(this.currentlyEdittedTask)) {
			return { singles: this.currentlyEdittedTask.likut.TeudaQuantity, packs: this.currentlyEdittedTask.likut.TeudaPackQuantity };
		}

		return { singles, packs };
	}

	normalizeCurrentlyEdittedTaskNumbers() {
		if (!this.currentlyEdittedTask && !this.currentlyEdittedTaskLikutMekabel) return;
		if (this.isProductWithLikut(this.currentlyEdittedTask)) {
			this.currentlyEdittedTask.likut.LikutQty = +formatNumberToMaxPrecision(+this.currentlyEdittedTask.likut.LikutQty || 0);
			this.currentlyEdittedTask.likut.LikutPackQty = +formatNumberToMaxPrecision(+this.currentlyEdittedTask.likut.LikutPackQty || 0);
			return;
		}

		if (this.isProductWithLikutMekabel(this.currentlyEdittedTaskLikutMekabel)) {
			this.currentlyEdittedTaskLikutMekabel.likut.TeudaQtyKabala = +formatNumberToMaxPrecision(+this.currentlyEdittedTaskLikutMekabel.likut.TeudaQtyKabala || 0);
			this.currentlyEdittedTaskLikutMekabel.likut.TeudaPackQtyKabala = +formatNumberToMaxPrecision(+this.currentlyEdittedTaskLikutMekabel.likut.TeudaPackQtyKabala || 0);
			this.currentlyEdittedTaskLikutMekabel.likut.PriceOut = +formatNumberToMaxPrecision(+this.currentlyEdittedTaskLikutMekabel.likut.PriceOut || 0);
			this.currentlyEdittedTaskLikutMekabel.likut.DiscountOut = +formatNumberToMaxPrecision(+this.currentlyEdittedTaskLikutMekabel.likut.DiscountOut || 0);
			return;
		}
	}

	getCollectedInCurrentlyEdittedProduct() {
		const { singles, packs } = this.getSinglesAndPacksInCurrentlyEdittedProduct();
		let itemID = '',
			collected = 0,
			collectedPacks = 0,
			docID = '';

		if (this.isProductWithLikut(this.currentlyEdittedTask)) {
			const { likut } = this.currentlyEdittedTask;
			itemID = likut.ProductId;
			collected = likut.LikutQty;
			collectedPacks = likut.LikutPackQty;
			docID = likut.TeudaNum;
			return { singles, packs, itemID, collected, collectedPacks, docID };
		}

		if (this.isLikutMekabel) {
			itemID = this.currentlyEdittedTaskLikutMekabel.likut.ProductId;
			collected = this.currentlyEdittedTaskLikutMekabel.likut.TeudaQtyKabala;
			collectedPacks = this.currentlyEdittedTaskLikutMekabel.likut.TeudaPackQtyKabala;
			docID = this.currentlyEdittedTaskLikutMekabel.likut.TeudaNum;
		}

		return { singles, packs, itemID, collected, collectedPacks, docID };
	}

	enforceMaxTextLength(e: Event, mode: 'eitur' | 'remark') {
		if (e instanceof KeyboardEvent && e.target instanceof HTMLTextAreaElement) {
			this.form.controls[mode].reset(e.target.value.slice(0, 100));
		}
	}

	getOrSetDisplayTask(mode: 'get'): void;
	getOrSetDisplayTask(mode: 'set', newValue: ProductDisplay[]): void;
	getOrSetDisplayTask(mode: 'get' | 'set', newValue = this.productDisplay$.value): void {
		// if (!this.isTruckDistribution) return;
		// let key = '',
		// 	clientid = '',
		// 	address = '',
		// 	status = '';
		// if (this._truckDistribution.truckDistributionOpened.task) {
		// 	({ clientid, address, status } = this._truckDistribution.truckDistributionOpened.task);
		// 	key = `Task-${clientid},${status},${address}`;
		// }
		// if (mode === 'get') {
		// 	if (!key || !clientid || !address || !status) return;
		// 	const stored = localStorage.getItem(key);
		// 	if (stored) {
		// 		const parsed: { sub: ProductDisplay[]; main: TruckDistributionTaskDisplayExtended; finishOptions?: { signature: string } } = JSON.parse(decompress(stored));
		// 		if (parsed?.sub?.length && this.pageMode$.value.includes('truck')) {
		// 			console.log(parsed);
		// 			this.productDisplay$.next(parsed.sub);
		// 			this.taskID = parsed.main.taskID;
		// if (this.isTruckDistribution) {
		// 	this._truckDistribution.truckDistributionOpened.sub = parsed.sub.map(task => task.truckTask as TruckDistributionSubOpened);
		// 	if (parsed.finishOptions?.signature) {
		// 		this._truckDistribution.truckDistributionOpened.finishOptions = parsed.finishOptions;
		// 	}
		// }
		// 		}
		// 	}
		// }
		// if (mode === 'set') {
		// 	this._truckDistribution.truckDistributionOpened.sub = newValue.map(task => task.truckTask as TruckDistributionSubOpened);
		// const main = this._truckDistribution.truckDistributionOpened.task;
		// const finishOptions = this._truckDistribution.truckDistributionOpened.finishOptions;
		// const stringified = compress(JSON.stringify({ sub, main, finishOptions }));
		// localStorage.setItem(key, stringified);
		// }
	}

	openAddNewProductForMekabelPopup() {
		this.isAddNewProductForMekabelPopupOpen$.next(true);
	}

	handleRouteSelectNewProductForMekabelOrMelaket(e: MatAutocompleteSelectedEvent) {
		if (this.isNewTask) {
			this.handleSelectNewProductForMekabel(e);
			return;
		}

		this.handleSelectNewProductForMelaket(e);
	}

	handleSelectNewProductForMelaket(e: MatAutocompleteSelectedEvent) {
		const addedItem = this.handleAddNewProductToTaskForMelaket(e.option.value);
		this.handleAddSelectedProductForMelaket(addedItem);
		this.refreshBarcodeDefinitions();
	}

	handleSelectNewProductForMekabel(e: MatAutocompleteSelectedEvent) {
		const addedItem = this.handleAddNewProductToTaskForMekabel(e.option.value);
		this.handleAddSelectedProductForMekabel(addedItem);
		this.refreshBarcodeDefinitions();
	}

	handleAddSelectedProductForMekabel(product: LikutMekabelDisplay, options: { skipPopup: boolean } = { skipPopup: false }) {
		this.productsAlreadyAddedSet.add(product.likut.ProductId);
		this._likut.addMekabelWarehouseControl(product.likut);
		this.isAddNewProductForMekabelPopupOpen$.next(false);
		this.addProductFormControl.reset();
		if (options.skipPopup) return;
		this.handleLikutMekabelPopupOpen(product);
	}
	handleAddSelectedProductForMelaket(product: LikutProductDisplayNewRoute, options: { skipPopup: boolean } = { skipPopup: false }) {
		this.productsAlreadyAddedSet.add(product.likut.ProductId);
		this.isAddNewProductForMekabelPopupOpen$.next(false);
		this.addProductFormControl.reset();
		if (options.skipPopup) return;
		this.handlePopupOpen(product);
	}

	handleAddNewProductToTaskForMekabel(product: AllProducts) {
		const likutDisplay = this.handleGenerateLikutMekabelDisplayFromAllProducts(product);
		const { likut } = likutDisplay;

		this._likut.likutMekabelOpenedState.main.rows = [...this._likut.likutMekabelOpenedState.main.rows, { ...likut }];

		this.likutMekabelDisplay$.next([...this.likutMekabelDisplay$.value, { likut, taskIdentifier: this._likut.getLineIdentifier(likut) }]);
		return likutDisplay;
	}

	handleAddNewProductToTaskForMelaket(product: AllProducts) {
		const availableTeudaLineNum = this._likut.getFirstAvailableTeudaLineNum('likut');
		const productDisplay = this._likut.handleGenerateProductDisplayFromAllProducts({ product, manuallyAdded: true, forcedLineNum: availableTeudaLineNum });

		this._likut.likutOpenedNewRoutesState.sub.push(productDisplay.likut);

		this.likutProductDisplayNewRoutes$.next([...this.likutProductDisplayNewRoutes$.value, productDisplay]);

		return productDisplay;
	}

	handleForgetOriginalStock() {
		if (this.isLikutMekabel) {
			for (const product of this._likut.likutMekabelOpenedState.main.rows) {
				delete product.Stock;
			}
			return;
		}

		if (this.isLikut) {
			for (const product of this._likut.likutOpenedNewRoutesState.sub) {
				delete product.Stock;
			}
		}
	}

	handleGenerateLikutMekabelDisplayFromAllProducts(product: AllProducts): LikutMekabelDisplay {
		const likut = {
			Barcode: product.ItemBarcode,
			DiscountOut: 0,
			Eitur: '',
			ItemRemark: '',
			PriceOut: 0,
			ProductId: product.ProductId,
			TeudaNum: this._likut.likutMekabelOpenedState.main.refrenceNumber,
			TeudaPackQtyKabala: 0,
			TeudaQtyKabala: 0,
			Currency: '',
			Discount: 0,
			Extra1: '',
			Extra2: '',
			Extra3: '',
			Extra4: '',
			Extra5: '',
			ItemPack: product.ItemPack,
			ItemPicName: product.ItemPicName,
			ItemStatus: '0',
			Price: product.Price,
			ProductName: product.Product_Name,
			Rate: 0,
			Stock: product.Stock,
			TeudaLineNum: this._likut.likutMekabelOpenedState.main.rows.length + 1,
			TeudaPackQty: 0,
			TeudaQty: 0,
			TeudaType: this._likut.likutMekabelOpenedState.main.doctype.num,
			Warehouse: this._likut.likutMekabelOpenedState.main.warehouse.id,
		} as LikutKabalaSubSQL;
		return {
			opened: true,
			likut,
			taskIdentifier: this._likut.getLineIdentifier(likut),
		};
	}

	handleDeleteLikutMekabelProduct(product: LikutMekabelDisplay) {
		const index = this._likut.likutMekabelOpenedState.main.rows.findIndex(row => row.TeudaLineNum === product.likut.TeudaLineNum);
		this._likut.likutMekabelOpenedState.main.rows.splice(index, 1);
		this._likut.likutMekabelOpenedState.main.rows = [...this._likut.likutMekabelOpenedState.main.rows.map((row, i) => ({ ...row, TeudaLineNum: +i + 1 }))];
		this.likutMekabelDisplay$.next(
			this.likutMekabelDisplay$.value.filter(prod => prod.likut.TeudaLineNum !== product.likut.TeudaLineNum).map((prod, i) => ({ ...prod, likut: { ...prod.likut, TeudaLineNum: +i + 1 } })),
		);
		const numOfTimesProductIsInList = this._likut.likutMekabelOpenedState.main.rows.filter(row => row.ProductId === product.likut.ProductId).length;
		if (numOfTimesProductIsInList === 0) {
			this.productsAlreadyAddedSet.delete(product.likut.ProductId);
		}
		this.productToBeDeleted$.next(null);
		if (this.isLikutScannerActive) {
			this.refreshBarcodeDefinitions();
			this._likutScan.clearItemFromScanHistory(product.likut);
		}
		this.handlePopupClose();
	}

	handleDeleteLikutMelaketProduct({ likut }: LikutProductDisplayNewRoute) {
		this._likut.likutOpenedNewRoutesState.sub = this._likut.likutOpenedNewRoutesState.sub.filter(
			row => getLineIdentifier({ mode: 'likut', task: row }) !== getLineIdentifier({ mode: 'likut', task: likut }),
		);
		this.likutProductDisplayNewRoutes$.next(
			this.likutProductDisplayNewRoutes$.value.filter(prod => getLineIdentifier({ mode: 'likut', task: prod.likut }) !== getLineIdentifier({ mode: 'likut', task: likut })),
		);
		const numOfTimesProductIsInList = this._likut.likutOpenedNewRoutesState.sub.filter(row => row.ProductId === likut.ProductId).length;
		if (!numOfTimesProductIsInList) {
			this.productsAlreadyAddedSet.delete(likut.ProductId);
		}
		this.melaketProductToBeDeleted$.next(null);
		if (this.isLikutScannerActive) {
			this.refreshBarcodeDefinitions();
			this._likutScan.clearItemFromScanHistory(likut);
		}
		this.handlePopupClose();
	}

	openScannerForAddNewProductPopup(e: Event) {
		e.stopPropagation();
		this.handleBarcodePopupOpen();
	}
	//likut-scan
	handleLikutScannerFunctionality() {
		if (!this.isLikutScannerActive) return;

		this._barcode
			.createBarcodeStream()
			.pipe(takeUntil(this.destroy$))
			.subscribe(async barcodeScan => {
				if (this.dialog.openDialogs.length) return;

				// might be redundant since barcodeStream already filters shift
				barcodeScan = barcodeScan.toLowerCase().replaceAll('shift', '');

				if (this.isEditQuantityPopupShown$.value) {
					if (this.shouldIgnoreScanListeningWhilePopupOpen) return;
					if (this.isProductWithLikut(this.currentlyEdittedTask) || this.isProductWithLikutMekabel(this.currentlyEdittedTaskLikutMekabel)) {
						const { weight } = this.deconstructBarcode(barcodeScan);

						if (!isFinite(+weight) || weight <= 0) {
							console.log('not a valid weight');
							return;
						}

						let task: LikutKabalaSubSQL | LikutSubSQL = this.currentlyEdittedTaskLikutMekabel?.likut;
						if (this.isProductWithLikut(this.currentlyEdittedTask)) {
							task = this.currentlyEdittedTask.likut;
							if (this.checkboxState[getLineIdentifier({ mode: 'likut', task })]) {
								this.openSnackbarForAlreadyCheckedAndCannotBeScanned();
								return;
							}
						}

						this._likutScan.addCustomBarcodeScan({ quantity: weight, task, source: scanHistoryOriginSource.popupScreen_BarcodeStream, barcode: barcodeScan });
					}
					return;
				}

				const definitions = this._likutScan.getBarcodesDefinitions([], { shouldFilterByRelevantTask: false });
				const relevantBarcodeDefinition = this._likutScan.matchBarcodeToCorrectDefinition(barcodeScan, definitions);
				if (relevantBarcodeDefinition) {
					const prod = this.allProductsForAddNewProductPopup.find(prod => prod.ProductId === relevantBarcodeDefinition.productWithBarcode.ProductId);
					if (!prod) {
						this.openSnackbarForNoBarcode(barcodeScan);
						return;
					}
					const isProductAlreadyAdded = this.productsAlreadyAddedSet.has(prod.ProductId);
					if (isProductAlreadyAdded) {
						const response = await this._alert.customConfirmAlertWithoutBackdropClose(`האם להוסיף פריט ${relevantBarcodeDefinition.productWithBarcode.ProductId} - ${prod.Product_Name} למשימה?`);
						if (!response) {
							return;
						}
					}

					if (prod) {
						if (this.isLikutMekabel) {
							const display = this.handleAddNewProductToTaskForMekabel(prod);
							this.handleAddSelectedProductForMekabel(display);
						} else {
							const display = this.handleAddNewProductToTaskForMelaket(prod);
							this.handleAddSelectedProductForMelaket(display);
						}
						// this._likutScan.handleScanBarcodeCheckAndAddToHistory({
						// 	barcode: barcodeScan,
						// 	productWithBarcodeDefinitions: [relevantBarcodeDefinition],
						// 	source: scanHistoryOriginSource.mainScreen_BarcodeStream,
						// 	// if we are adding a new product, it wont be in the checkbox state
						// 	checkboxStateDictionary: {},
						// });

						// this.refreshBarcodeDefinitions();
						return;
					}
				}

				this.openSnackbarForNoBarcode(barcodeScan);
			});
	}

	handleWarehousePick() {
		const dialogRef = this.dialog.open(LikutClientsWarehouseDialogComponent, { width: '80vw', data: { onlyWarehouse: true } });

		dialogRef
			.afterClosed()
			.pipe(takeUntil(this.destroy$))
			.subscribe((result: NewLikutMekabelWarehouseFormResult | 'cancel' | undefined) => {
				if (result && result !== 'cancel') {
					this._likut.updateSfiraWarehouseSelected(result.warehouse);
					return;
				}

				this._router.navigate(['home'], { replaceUrl: true });
				return;
			});
	}

	deconstructBarcode(barcode: string): { barcode: string; weight: number } {
		barcode = barcode
			.trim()
			.split('')
			.filter(char => char !== this._barcode.barcodePrefixCharacter && char !== this._barcode.barcodeSuffixCharacter)
			.join('');

		const weight = +barcode.slice(7, 12) / 1000;
		barcode = barcode.slice(1, 7);
		return { barcode, weight };
	}

	displayFnProduct(input: AllProducts): string {
		return input?.Product_Name || '';
	}

	refreshBarcodeDefinitions() {
		if (this.isLikutMekabel) {
			this.relevantBarcodeDefinitions = this._likutScan.getBarcodesDefinitions(this._likut.likutMekabelOpenedState.main.rows);
		} else {
			this.relevantBarcodeDefinitions = this._likutScan.getBarcodesDefinitions(this._likut.likutOpenedNewRoutesState.sub);
		}
	}

	private _filterProduct(name: string | AllProducts): AllProducts[] {
		const filterValue = typeof name === 'string' ? name.toLowerCase() : '';

		return genericSearchingFunction(filterValue, this.allProductsForAddNewProductPopup, ['Product_Name', 'ProductId', 'ItemBarcode']).filter(
			prod => !this.productsAlreadyAddedSet.has(prod.ProductId),
		);
	}

	// type completion for template
	isProductWithLikut(product: ProductDisplay | LikutProductDisplayNewRoute | LikutMekabelDisplay): product is LikutProductDisplayNewRoute {
		if (!product) return false;
		return 'likut' in product && 'TeudaQuantity' in product.likut;
	}
	isProductWithLikutMekabel(product: ProductDisplay | LikutProductDisplayNewRoute | LikutMekabelDisplay): product is LikutMekabelDisplay {
		if (!product) return false;
		return 'likut' in product && 'TeudaQtyKabala' in product.likut;
	}
}
